module.exports = __webpack_public_path__ + "static/img/87_phase_function_Paper_PointsHejduk_Prediction.4b13b80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/87_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ey2a
// module chunks = 0